import path from 'path'
path.resolve(__dirname, '../next.config.js')
export {
  getServerSideProps,
  Homepage as default,
} from '@cinch-nx/landing-feature-homepage'
